import React from 'react'

const Manual_posibles_modificaciones_portal_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Posibles modificaciones | Portal Clau.io
        </h2>
        <iframe
          src="https://scribehow.com/embed/Posibles_modificaciones_or_Portal_Clauio__hUnZ-AuYSie9ChEvbT8trg?as=scrollable"
          className="scribe-iframe-general-77"
          width="100%"
          height="3400"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_posibles_modificaciones_portal_clau
